<template>
	<div class="pa-3">
		<v-breadcrumbs :items="breadcrumbs" divider="&gt;"></v-breadcrumbs>

		<v-card :class="{ 'is-fade': loading }">
			<v-card-text>
				<template v-for="headline in headlines" v-if="headline.editable">
					<h3><v-chip v-if="!headline.editable" class="caption" color="green lighten-4 mr-2" small>AUTO</v-chip>{{ headline.title }}</h3>
				    <v-flex xs12>
				    	<v-sheet color="grey lighten-3" class="contents-wide-wrapper mb-3">
				    		<v-btn large icon class="add-content" @click="selectedSlot = headline.slot">
								<v-icon>add_circle</v-icon>
				    		</v-btn>

							<selected-content-card 
								class="selected-content-card"
								v-for="(content, index) in headline.contents" 
								:key="index" 
								:content="content" 
								:allow-remove="true"
								:item="content"
								@on-remove="handleRemoveContent(content, $event)">
								<template slot="footer" slot-sope="content">
									<v-btn flat color="error" @click="handleUpdateExpiresDate(content)" small>{{ dayLeft(content.expiresAt) }}</v-btn>
								</template>
							</selected-content-card>
				    	</v-sheet>
				 	</v-flex>
			 	</template>	
			</v-card-text>
		</v-card>

		<headline-edit-modal
			v-model="openEditModal"
			:content="contentToBeEdited"
			@update="handleContentUpdate"
			@close="contentToBeEdited = null">
		</headline-edit-modal>

		<related-content-list-picker
			:title="selectedTitle"
			:contents="selectedContents"
			:specific-content-type="selectedContentType"
			@action="handlePickerAction"
			@close="handleClosePicker">
		</related-content-list-picker>
	</div>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

	import Draggable from 'vuedraggable'
	import RelatedContentListPicker from '@/components/RelatedContentListPicker.vue'
	import SelectedContentCard from '@/components/SelectedContentCard.vue'
	import HeadlineEditModal from '@/views/promote/headline/HeadlineEditModal.vue'

	export default {
		components: {
			Draggable,
			RelatedContentListPicker,
			SelectedContentCard,
			HeadlineEditModal
		},
		data () {
			return {
				breadcrumbs: [
					{
						text: 'Home',
						disabled: false,
						href: config.PUBLIC_PATH
					},
					{
						text: 'Promote',
						disabled: true,
						href: `${config.PUBLIC_PATH}promote`
					},
					{
						text: 'Headline',
						disabled: true,
						href: `${config.PUBLIC_PATH}promote/headline`
					}
				],
				headlines: [
					{
						slot: 1,
						title: 'Spotlight Items',
						editable: true,
						contents: []
					},
					{
						slot: 2,
						title: 'Hero Contents',
						editable: true,
						contents: []
					},
					{
						slot: 3,
						title: 'Top Contents (Comment)',
						editable: false,
						contents: []
					},
					{
						slot: 4,
						title: 'Speak Out',
						editable: true,
						contents: []
					},
					{
						slot: 5,
						title: 'Top Contents (View)',
						editable: false,
						contents: []
					},
					{
						slot: 6,
						title: 'Top Contents (Love)',
						editable: false,
						contents: []
					},
					{
						slot: 7,
						title: 'Jeban\'s Supporter',
						editable: true,
						contents: []
					}
				],
				selectedSlot: 0,
				now: null,
				contentToBeEdited: null,
				openEditModal: false,
				loading: true
			}
		},
		computed: {
			selectedTitle () {
				return !this.selectedSlot ? '' : this.headlines.filter(h => h.slot == this.selectedSlot)[0].title
			},
			selectedContents () {
				return (!this.selectedSlot) ? null : this.headlines[this.selectedSlot - 1].contents
			},
			selectedContentType () {
				switch (this.selectedSlot) {
					case 1:
						return 'SPOTLIGHT'
						break;
					default: 
						return ''
						break;
				}
			}
		},
		methods: {
			dayLeft (date) {
				if (!this.now) { this.now = new Date() }

				let hours = (Math.abs(Date.parse(this.now) - Date.parse(date)) / 36e5).toFixed(0)
				let days = days = Math.floor(hours / 24).toFixed(0)

				let returnString = ``

				switch (true) {
					case days > 0:
						hours = (days * 24) - hours

						returnString = `${days} days left`
						returnString += (hours > 0) ? `, ${hours} hours left.` : `.`
						break
					default:
						returnString = `${hours} hours left.`
						break
				}

				return returnString
			},
			contentLink (content) {
				switch (content.contentType) {
					case 'CHECK':
						return `/beautycheck/${content.id}`
						break
					case 'SPOTLIGHT':
						return `/spotlight/${content.slug}`
						break
					default:
						return `/${content.contentType.toLowerCase()}/${content.id}`
						break
				}
			},
			handleUpdateExpiresDate (content) {
				if (this.contentToBeEdited !== null) this.contentToBeEdited = null
				this.contentToBeEdited = content
				event.stopPropagation()
			},
			handleContentUpdate (content) {
				let oldContent = this.headlines[content.slotNo - 1].contents.filter((c) => { return c.id == content.id})
				let oldIndex = this.headlines[content.slotNo - 1].contents.indexOf(oldContent)

				this.headlines[content.slotNo - 1].contents[oldIndex] = content
			},
			handleRemoveContent (content, event) {
				this.$swal({
					text: "Remove Headline Content?",
					type: "warning",
					showCancelButton: true
				}).then(response => {
					if (response.value == true) {
						this.loading = true

						axios.delete(`${config.BASE_URL}/headline/content/${content.id}`)
							.then(response => {
								let contentIndex = this.headlines[content.slotNo - 1].contents.indexOf(content)
								this.headlines[content.slotNo - 1].contents.splice(contentIndex, 1)
								this.loading = false
							})
					}
				})
				event.stopPropagation()
			},
			handlePickerAction (content) {
				let slot = this.selectedSlot

				this.loading = true
				this.handleClosePicker()

				let item = {
					'slotNo': slot,
					'contentType': content.contentType,
					'contentId': content.contentId,
					'type': ((content.contentType == 'TOPIC') || (content.contentType == 'CHECK')) ? content.type : ((content.contentType == 'SPOTLIGHT') ? 'Spotlight Item' : content.contentType.toLowerCase()),
					'title': content.title,
					'url': this.contentLink(content),
					'coverUrl': content.coverUrl,
					'responsiveCoverFile': content.responsiveCoverFile,
					'intention': (content.contentType == 'TOPIC') ? content.intention : null,
					'sponsoredBy': (content.contentType == 'TOPIC') ? content.sponsoredBy : null,
					'content': content
				}

				axios.post(`${config.BASE_URL}/headline/content`, item)
					.then(response => {
						this.headlines[slot - 1].contents = [response.data.data].concat(this.headlines[slot - 1].contents)
						this.loading = false
					})
			},
			handleClosePicker () {
				this.selectedSlot = null
			}
		},
		mounted () {
			axios.get(`${config.BASE_URL}/headline/content`)
				.then(response => {
					this.now = new Date()

					if (response.data.data.headlineContentList) {
						response.data.data.headlineContentList.filter(h => h.slotNo <= 7).forEach(content => {
							this.headlines[content.slotNo - 1].contents.push(content)
						})
					}

					this.loading = false
				})
		},
		watch: {
			contentToBeEdited (newValue) {
				this.openEditModal = newValue ? true : false
			}
		}
	}
</script>

<style lang="scss">
	.contents-wide-wrapper {
		overflow-x: scroll;
		overflow-y: hidden;
		white-space: nowrap;

		height: 250px;
		margin: .5rem 0 2rem !important;

		.selected-content-card-wide-wrapper {
			padding-top: 1rem;
			padding-bottom: 1rem;
			
			&:not(:last-child) {
				border-bottom: 1px dashed #ccc;
			}
		}

		.selected-content-card {
			display: inline-block;
			width: 216px;
			margin: 10px;

			.v-card__title {
				height: 68px;
				padding: 10px;
				align-items: flex-start;
				white-space: pre-wrap;
			}
		}

		.add-content {
			margin-bottom: 190px;
		}
	}
</style>